import LayoutChild from "@/layouts/LayoutChild.vue";
import LayoutArticle from "@/layouts/LayoutArticle.vue";

export default [{
  path: "/news",
  name: "news",
  meta: {
    title: "新闻动态",
  },
  // component: LayoutChild,
  component: () => import("@/views/news/news.vue"),
  // redirect: "",
  // children: [],
},
// 
{
  path: "/news-detail",
  name: "news-detail",
  meta: {
    title: "新闻动态",
    hidden: true,
  },
  component: LayoutArticle,
  redirect: "/news/detail",
  children: [{
    path: "/news/detail",
    name: "news_detail",
    meta: {
      title: "文章详情",
      keepAlive: true,
    },
    component: () => import("@/views/news/detail.vue"),
  },],
},
{
  path: "/news-category",
  name: "news-category",
  meta: {
    title: "新闻动态",
    hidden: true
  },
  component: LayoutChild,
  redirect: "/news",
  children: [{
    path: "/news/category/:id",
    name: "news_category",
    meta: {
      title: "",
      keepAlive: true,
    },
    component: () => import("@/views/news/category.vue"),
  },

  ],
},
];